import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Typography, message, Space } from 'antd';
import request from '@/utils/request';

const FIELDS: Array<{ key: string; label: string; help?: string }> = [
  { key: 'exchangeRate.usdToRmb', label: '美元对人民币汇率', help: 'fal.ai 计费 USD → RMB' },
  { key: 'pricing.markupFactor', label: '定价倍率', help: '成本 × 倍率 = 消费者价格（向上取整到分）' },
  { key: 'pricing.creatorShareFactor', label: '创作者分成倍率', help: '成本 × 倍率 = 创作者每单收入' },
  { key: 'coinsPerRmb', label: '1 元兑换虚拟币数量', help: '默认 10' },
  { key: 'upload.consumerMaxMb', label: '消费者上传单图上限 (MB)' },
  { key: 'upload.creatorMaxMb', label: '创作者资源单图上限 (MB)' },
  { key: 'upload.consumerMaxCount', label: '消费者单次最多上传张数' },
  { key: 'bundle.minPriceCoins', label: '套图最低售价（币）' },
  { key: 'gift.defaultExpireDays', label: '礼物默认过期天数' },
  { key: 'withdrawal.minAmountCents', label: '最低提现金额（分）' },
  { key: 'creator.welcomeBonusCents', label: '新创作者体验金（分）' },
];

const MarketplaceSettingsPage: React.FC = () => {
  const [form] = Form.useForm<Record<string, string>>();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await request.get<Record<string, string>>('/admin/purchases/settings');
      const data = res.data as unknown as Record<string, string>;
      form.setFieldsValue(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    const values = form.getFieldsValue();
    setSaving(true);
    try {
      await request.patch('/admin/purchases/settings', values);
      message.success('已保存');
    } catch (e) {
      if (e instanceof Error) message.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Typography.Title level={3} style={{ margin: 0 }}>
        市场参数
      </Typography.Title>
      <Card loading={loading}>
        <Form form={form} layout="vertical">
          {FIELDS.map((f) => (
            <Form.Item key={f.key} name={f.key} label={f.label} extra={f.help}>
              <Input />
            </Form.Item>
          ))}
          <Button type="primary" loading={saving} onClick={save}>
            保存
          </Button>
        </Form>
      </Card>
    </Space>
  );
};

export default MarketplaceSettingsPage;
